module.exports = "/images/dz.svg?5bc24681d1cb9ef57619cc1c8175601d";